import React from "react";
import strings from "../../helpers/Localization";
import Popover from "@mui/material/Popover";
import IconComponent from "../Icons/IconComponent";

const Dropdown = ({ disabled, placeHolder, maxWidth, list, value, openTop, adjustHeight, emptyTitle, preventEmpty, onChange }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const [showOptionList, setShowOptionList] = React.useState(false);
    const [defaultSelectText, setDefaultSelectText] = React.useState(() => {
        if (Array.isArray(list) && value != null) {
            const found = list.find(op => op && op.id != null && String(op.id) === String(value));
            return found && found.name || "";
        }
        return "";
    });

    React.useEffect(() => {
        if (Array.isArray(list) && value != null) {
            const found = list.find(op => op && op.id != null && String(op.id) === String(value));
            setDefaultSelectText(found && found.name || "");
        }
        else {
            setDefaultSelectText("");
        }
    }, [list, value]);

    const handleClick = (event) => {
        if (!open) {
            setAnchorEl(event.currentTarget);
        }
        else {
            handleClose();
        }
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleOptionClick = (e, option) => {
        onChange(option);
        setShowOptionList(false);
        handleClose();
    };


    const tabHeight = 30;
    const maxHeight = 180;

    const listHeight = list ? Math.min((list.length + 1) * (tabHeight + 12), maxHeight) : maxHeight;

    return <div className="custom-select-container"
        onClick={(e) => {if (!disabled) {handleClick(e);}}}
        style={{ zIndex: showOptionList ? "1000" : "500",
            opacity: disabled ? 0.5 : 1,
            flexGrow: "1", flex: "1", flexShrink: "0", maxWidth: maxWidth ? maxWidth + "px" : null,
            border: "1px solid",
            borderColor: open ? "var(--grey-light)" : "var(--grey-lighter)",
            borderRadius: openTop && showOptionList ? "0px 0px 6px 6px" : "6px 6px 0px 0px",
            //boxShadow: showOptionList ? "0px 0px 8px 0px rgba(0, 0, 0, 0.25)" : null,
            marginBottom: showOptionList && !openTop && adjustHeight ? listHeight + "px" : "0px",
            marginTop: showOptionList && openTop && adjustHeight ? listHeight + "px" : "0px"
        }}>
        <div
            className={showOptionList ? "selected-text active" : "selected-text"}
            style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
        >
            <span style={{ marginBottom: "3px", fontSize: "14px" }}>{placeHolder && defaultSelectText === emptyTitle || defaultSelectText === "" ? placeHolder : defaultSelectText}</span>
            <span style={{ display: "flex", flexGrow: "1" }}/>
            <div style={{ pointerEvents: "none", width: "24px", height: "24px", marginTop: "-1px" }}>
                <IconComponent dimensions="24" nameIcon={open ? "chevronUp" : "chevronDown"} color={"carbone"}/>
            </div>
        </div>
        <Popover anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "center"
            }}
            transformOrigin={{
                vertical: "top",
                horizontal: "center"
            }}>
            <div className="dropdown-container"
                style={{
                    border: "1px solid var(--grey-light)",
                    overflowY: "auto",
                    opacity: open ? 1 : 0,
                    width: open ? anchorEl.offsetWidth : "450" + "px",
                    minHeight: "50px", maxHeight: "190px", display: "flex", flexDirection: "column"
                }}
            >

                { !preventEmpty ?
                    <li className="custom-select-option"
                        data-name={emptyTitle ? emptyTitle : strings.None}
                        key={"None"}
                        onClick={(e) => handleOptionClick(e, null)}
                        style={{ cursor: "pointer", color: defaultSelectText === (emptyTitle ? emptyTitle : strings.None) ? "var(--primary-base)" : "auto", height: tabHeight + "px" }}
                    >
                        {emptyTitle ? emptyTitle : strings.None}
                    </li> : null}
                {
                    list.map((option) => {
                        if (option) {
                            return <li className="custom-select-option"
                                data-name={option.name}
                                key={option.id}
                                onClick={(e) => handleOptionClick(e, option)}
                                style={{ cursor: "pointer", color: option.name === defaultSelectText ? "var(--primary-base)" : "auto", height: tabHeight + "px" }}
                            >
                                {option.name}
                            </li>;
                        }
                    })
                }
            </div>
        </Popover>
    </div>;
};
export default Dropdown;
